import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';

interface ClaimCycleSamplingAnalysisReport {
  employee_code: string;
  employee_name: string;
  company_name: string;
  branch_name: string;
  claim_id: string;
  claim_date: Date | null;
  is_resubmission: boolean;
  total_resubmission_count: number;
  claim_type: string;
  claim_item_name: string;
  expense_txn_glcode: string;
  expense_txn_glname: string;
  claim_status: string;
  claim_document_line_ccy_code: string;
  claim_amount: number;
  descr: string | null;
  status: string;
}

interface ReportDTO {
  latest_reviewed_by_employee_name: string | null;
  finance_review_action: string | null;
  first_level_approver_action: string | null;
  employee_name: string;
  employee_code: string;
  comp_name: string;
  cycle_month: number;
  cycle_year: number;
  branch_name: string;
  claim_id: string;
  claim_type: string;
  claim_item_name: string;
  approval_workflow_type: string;
  date_claim_txn_start: Date;
  date_claim_txn_end: Date;
  claim_status: string;
  expense_txn_glcode: string;
  doc_currency_code: string;
  claim_amount: number;
  has_attachment: boolean;
  is_resubmission: boolean;
  is_flag: boolean;
  total_resubmission_count: number;
  claim_cycle_name: string;
}

interface ClaimCycleSamplingAnalysisReport2 {
  total_employees: number;
  total_claim_document_lines: number;
  total_chargeable: number;
  total_chargeable_percentage: number;
  total_non_chargeable: number;
  total_non_chargeable_percentage: number;
  total_non_chargeable_entitlement: number;
  total_non_chargeable_entitlement_percentage: number;
  total_normal_submission: number;
  total_normal_submission_percentage: number;
  total_resubmission: number;
  total_resubmission_percentage: number;
  total_flagged: number;
  total_flagged_percentage: number;
  total_first_level_mass_action_count: number;
  total_first_level_mass_action_percentage: number;
  total_first_level_individual_action_count: number;
  total_first_level_individual_action_percentage: number;
  total_finance_mass_review_count: number;
  total_finance_mass_review_percentage: number;
  total_finance_individual_review_count: number;
  total_finance_individual_review_percentage: number;
  bl_aat_claim_cycle_sampling_analysis_report_dto: ReportDTO[];
}


@Injectable({
  providedIn: 'root'
})
export class ClaimCycleSamplingAnalysisReportService extends BaseApiTemplateService<ClaimCycleSamplingAnalysisReport> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/sampling-analysis-reports/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/sampling-analysis-reports/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/sampling-analysis-reports/backoffice-ep';
    this.httpClient = http;
  }

  getSamplingAnalysisGuid(body: { sample_hdr_guid: string }, apiVisa: ApiVisa): Observable<ClaimCycleSamplingAnalysisReport[]> {
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ClaimCycleSamplingAnalysisReport[]>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getSamplingAnalysisGuids(body: { sample_hdr_guids: string[] }, apiVisa: ApiVisa): Observable<ClaimCycleSamplingAnalysisReport[]> {
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ClaimCycleSamplingAnalysisReport[]>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getSamplingAnalysisReport2(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/audit-trail-export/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  generateSamplingAnalysisReport(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getSamplingAnalysisReport3(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/audit-trail-export/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  generateSamplingAnalysisReportForMultipleCompanies(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleSamplingAnalysisReport2>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  auditTrailExportButton(body: {}, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/audit-trail-export/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  auditTrailExportButtonForMultipleCompanies(body: {}, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/audit-trail-export/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/sampling-analysis-reports/multiple-companies/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

}


